import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import { validateEmail } from '../utils/validation';
import { trackEvent } from '../utils/analytics';
import { ErrorMessage, SuccessMessage } from './common';
import './Auth.css';

function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const { forgotPassword } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    trackEvent('forgot_password_submit');
    setError('');
    setSuccess('');

    const emailError = validateEmail(email, t);
    if (emailError) {
      trackEvent('forgot_password_failed', { reason: 'invalid_email_format' });
      setError(emailError);
      return;
    }

    setLoading(true);
    const result = await forgotPassword(email);

    if (result.success) {
      trackEvent('forgot_password_success');
      setSuccess(result.message);
      setEmail('');
    } else {
      trackEvent('forgot_password_failed', { reason: 'server_error' });
      setError(result.error);
    }

    setLoading(false);
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>{t('auth.forgotPassword.title')}</h2>

        <ErrorMessage message={error} />
        <SuccessMessage message={success} />

        <p className="auth-description">
          {t('auth.forgotPassword.description')}
        </p>

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">{t('auth.forgotPassword.email')}</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
              placeholder={t('auth.forgotPassword.emailPlaceholder')}
            />
          </div>

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? t('auth.forgotPassword.submitting') : t('auth.forgotPassword.submit')}
          </button>
        </form>

        <div className="auth-links">
          <Link to="/login" className="link-button">
            {t('auth.forgotPassword.backToLogin')}
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
